import baseApi from "~/common/services/base-api";

export const fetchPhotos = async (page: number, pageSize: number) => {
  return baseApi
    .get(`/photos?page=${page}&pageSize=${pageSize}`)
    .then((res) => res.data);
};
